
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1(05|27|50)|312|806)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
